import { TidySelectBooleanValueModel, TidySelectNumberValueModel, TidySelectStringValueModel } from 'src/models/tidy-select-item.model';

/** Parking choices shared by Edit Property and the guidebook's How to Park card. */

export type ParkingOption = TidySelectBooleanValueModel | TidySelectStringValueModel | TidySelectNumberValueModel;

export const PARKING_TYPE_OPTIONS: TidySelectBooleanValueModel[] = [
  { viewValue: 'Free', value: false },
  { viewValue: 'Paid', value: true },
];

export const PAID_PARKING_SPOT_OPTIONS: TidySelectStringValueModel[] = [
  { viewValue: 'Meter', value: 'meter' },
  { viewValue: 'Paid Lot', value: 'paidlot' },
];

export const FREE_PARKING_SPOT_OPTIONS: TidySelectStringValueModel[] = [
  { viewValue: 'Street', value: 'street' },
  { viewValue: 'My Spot / Driveway', value: 'myspot' },
  { viewValue: 'Guest Parking', value: 'guest' },
];

export const PARKING_PAY_OPTIONS: TidySelectStringValueModel[] = [
  { viewValue: 'Cash', value: 'cash' },
  { viewValue: 'Card', value: 'card' },
];

// Stored in cents, offered in whole dollars up to $30.
export const MAX_PARKING_COST_OPTIONS: TidySelectNumberValueModel[] = Array.from({ length: 30 }, (_, index) => ({
  viewValue: `Max $${index + 1}`,
  value: (index + 1) * 100,
}));

/** Readable label for a stored parking value; '' when unset or unknown. */
export function parkingOptionLabel(options: ParkingOption[], value: unknown): string {
  if (value === null || value === undefined || value === '') { return ''; }
  // The API can hand back cents as a string, so compare loosely.
  return options.find(option => String(option.value) === String(value))?.viewValue ?? '';
}
